import React from 'react';

const EstimationIndicator = ({ className }) => {
    return (
        <div className={`estimation-legend ${className ? `${className}` : ''}`}>
            <div className="estimation-legend__items">
                <span className="estimation-legend__item estimation-legend__item--confirmed">
                    <span className="estimation-legend__dot estimation-legend__dot--confirmed" aria-hidden="true" />
                    Confirmed
                </span>
                <span className="estimation-legend__divider" aria-hidden="true" />
                <span className="estimation-legend__item estimation-legend__item--derived">
                    <span className="estimation-legend__dot estimation-legend__dot--derived" aria-hidden="true" />
                    <span className="estimation-legend__derived-label">Derived</span>
                </span>
            </div>
            <span className="estimation-legend__message">
                Some values are estimated based on round size, stage, and investor activity.
            </span>
        </div>
    );
};

export default EstimationIndicator;
